import React, { Component } from 'react';
import { TEXT_SCROLL_TIME } from 'common/js/params';
import './index.styl';

class ScrollText extends Component {
    animateId;

    animating = false;

    scrollpx = 0;

    constructor(props) {
        super(props);
        this.scroll = React.createRef();
    }

    componentWillUnmount() {
        cancelAnimationFrame(this.animateId);
    }

    checkScroll = () => {
        if (!this.scroll.current) {
            this.animating = false;
            return false;
        }

        if (this.scroll.current.scrollHeight <= this.scroll.current.clientHeight) {
            this.animating = false;
            cancelAnimationFrame(this.animateId);
            return false;
        }

        if (!this.animating) {
            this.animating = true;
            this.animateId = requestAnimationFrame(this.scrollAnimate);
        }
        return true;
    };

    scrollAnimate = time => {
        if (!this.start) {
            this.start = time;
        }

        const diff = time - this.start;
        this.start = time;

        this.scrollpx += diff / TEXT_SCROLL_TIME;
        const remainH = this.scroll.current.scrollHeight - this.scroll.current.clientHeight + 10;

        if (this.scrollpx >= remainH) {
            setTimeout(() => {
                this.scrollpx = 0;
                this.scroll.current.scrollTop = 0;
                this.animateId = requestAnimationFrame(this.scrollAnimate);
            }, 1000);
            return;
        } else {
            this.scroll.current.scrollTop = this.scrollpx;
        }
        this.animateId = requestAnimationFrame(this.scrollAnimate);
    };

    render() {
        const clz = ['map-scroll-text', this.props.className || ''].join(' ');
        this.checkScroll();
        return (
            <p className={clz} ref={this.scroll}>
                {this.props.children}
            </p>
        );
    }
}

export default ScrollText;
